import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MutationButton from './MutationButton';
import { extendedMutationType } from '../../types';

ToggleMutationButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    toggleFlag: PropTypes.bool.isRequired,
    trueFlagText: PropTypes.string.isRequired,
    falseFlagText: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    extraConfirmationMessage: PropTypes.string,
    disabled: PropTypes.bool,
};

function ToggleMutationButton(props) {
    const {
        extendedMutation,
        confirmationMessage,
        extraConfirmationMessage = null,
        toggleFlag,
        trueFlagText,
        falseFlagText,
        icon,
        className,
        disabled = false,
    } = props;
    const text = toggleFlag ? trueFlagText : falseFlagText;
    return (
        <MutationButton
            className={`${className} button`}
            confirmationMessage={confirmationMessage}
            extraConfirmationMessage={extraConfirmationMessage}
            extendedMutation={extendedMutation}
            disabled={disabled}
            showConfirmationDialog
        >
            <FontAwesomeIcon icon={icon} />&nbsp;{text}
        </MutationButton>
    );
}

export default ToggleMutationButton;
